module.exports = __webpack_public_path__ + "img/15_52.afec8afc.png";